export const sizeMap = new Map<number, string>([
  [-1, "?"],
  [1, "XS"],
  [2, "S"],
  [3, "M"],
  [4, "L"],
  [5, "XL"],
  [6, "XXL"],
]);
